const ccc = `
<svg id="Capa_2"
     xmlns="http://www.w3.org/2000/svg"
     viewBox="0 0 876.14 925.92">
  <defs>
    <style>
      .cls-1{
        stroke:#933231;
      }
      .cls-1,
      .cls-2{
        fill:none;
        stroke-linecap:square;
        stroke-linejoin:round;
        stroke-width:35px;
      }

      .cls-2{
        stroke:#000;
      }
    </style>
  </defs>
  <g>
    <path class="cls-2"
      d="M19.04,715.55c-14.21-119.66,71.27-228.18,190.93-242.4,119.66-14.21,228.18,71.27,242.4,190.93,14.21,119.66-71.27,228.18-190.93,242.4"/>

    <path class="cls-1"
      d="M807.49,693.82c-96.52,72.14-233.25,52.37-305.39-44.16-72.14-96.52-52.37-233.25,44.16-305.39,96.52-72.14,233.25-52.37,305.39,44.16"/>

    <path class="cls-2"
      d="M393.8,22.98c110.73,47.52,161.98,175.82,114.45,286.55-47.52,110.73-175.82,161.98-286.55,114.45-110.73-47.52-161.98-175.82-114.45-286.55"/>
  </g>
</svg>
`;

export { ccc };
